(function () {
	const horizontalTabs = document.querySelectorAll('.horizontal-tabs');
	if (horizontalTabs === null || horizontalTabs === undefined) return;
	class Tabs {
		constructor(horizontalTab) {
			this.tabs = Array.from(horizontalTab.querySelectorAll('.horizontal-tabs__tab'));
			this.tabButtons = Array.from(horizontalTab.querySelectorAll('.horizontal-tabs__btn'));
			this.sentinel = horizontalTab.querySelector('.horizontal-tabs__sentinel');
			this.activeClass = 'horizontal-tabs__tab--active';
			this.activeBtnClass = 'horizontal-tabs__btn--active';
			this.tabTriggerLinks = Array.from(document.querySelectorAll('.horizontal-tabs-trigger'));
			this.nextBtn = horizontalTab.querySelector('.controls__horizontal--next');
			this.prevBtn = horizontalTab.querySelector('.controls__horizontal--prev');
			this.tabHeading = horizontalTab.querySelector('.horizontal-tabs__dynamic-heading');
			this.activeTab = this.tabs[0];
			this.activeBtn = this.tabButtons[0];
			this.activeIndex = 0;
		}

		init() {
			this.checkHash();

			this.setActiveTab(this.tabs[this.activeIndex], this.tabButtons[this.activeIndex]);
			this.setHeight(this.tabs[this.activeIndex]);

			this.addListeners();
		}

		checkHash() {
			const hash = window.location.hash.substring(1);
			console.log(hash);
			if (hash) {
				const tab = this.tabs.find(tab => tab.dataset.tab === hash);
				const button = this.tabButtons.find(button => button.dataset.tab === hash);
				console.log(tab, button);
				if (tab && button) {
					this.activeIndex = this.tabButtons.findIndex(button => button.dataset.tab === hash);
					this.activeTab = tab;
					this.activeBtn = button;
				}
			}
		}

		setActiveTab(tab, button) {
			this.activeTab.classList.remove(this.activeClass);
			tab.classList.add(this.activeClass);
			this.activeBtn.classList.remove(this.activeBtnClass);
			button.classList.add(this.activeBtnClass);
			this.activeTab = tab;
			this.activeBtn = button;
			this.tabHeading.innerHTML = button.textContent;
			window.location.hash = button.dataset.tab;
			// change the window hash without jumping
			// history.pushState(null, null, button.dataset.tab);
			// trigger the event
			// window.dispatchEvent(new HashChangeEvent('hashchange'));
			this.activeIndex = this.tabButtons.findIndex(button => button === this.activeBtn);
			this.scrollTo();
		}

		setHeight(tab) {
			const height = tab.querySelector('.horizontal-tabs__tab-content').scrollHeight;

			gsap.to(this.sentinel, {
				duration: 0.5,
				height: height,
				ease: 'power2.out',
			});
		}

		addListeners() {
			// Add click event listeners to each tab button
			this.tabButtons.forEach(button => {
				button.addEventListener('click', e => {
					if (button.classList.contains(this.activeBtnClass)) return;
					const tab = this.tabs.find(tab => tab.dataset.tab === button.dataset.tab);
					this.setActiveTab(tab, button);
					this.setHeight(tab);
				});
			});
			// Add a resize event listener to the window
			window.addEventListener('resize', () => {
				this.setHeight(this.activeTab);
			});
			// Add click event listeners to each tab trigger
			this.tabTriggerLinks.forEach(link => {
				link.addEventListener('click', e => {
					e.preventDefault();
					const tabName = link.querySelector('a').href.split('#')[1];
					const tabElement = this.tabs.find(tab => tab.dataset.tab == tabName);
					const button = this.tabButtons.find(button => button.dataset.tab === tabName);
					this.setActiveTab(tabElement, button);
					this.setHeight(tabElement);
				});
			});
			// watch for hash changes
			window.addEventListener('hashchange', () => {
				// this.checkHash();
				this.setActiveTab(this.activeTab, this.activeBtn);
				this.setHeight(this.activeTab);
			});
			// Add click event listeners to the next and previous buttons
			this.nextBtn.addEventListener('click', e => {
				e.preventDefault();
				if (this.activeIndex < this.tabButtons.length - 1) {
					const nextTab = this.tabButtons[this.activeIndex + 1];
					const nextTabElement = this.tabs.find(tab => tab.dataset.tab === nextTab.dataset.tab);
					this.setActiveTab(nextTabElement, nextTab);
					this.setHeight(nextTabElement);
				} else {
					const firstTab = this.tabButtons[0];
					const firstTabElement = this.tabs.find(tab => tab.dataset.tab === firstTab.dataset.tab);
					this.setActiveTab(firstTabElement, firstTab);
					this.setHeight(firstTabElement);
				}
			});
			this.prevBtn.addEventListener('click', e => {
				e.preventDefault();
				if (this.activeIndex > 0) {
					const prevTab = this.tabButtons[this.activeIndex - 1];
					const prevTabElement = this.tabs.find(tab => tab.dataset.tab === prevTab.dataset.tab);
					this.setActiveTab(prevTabElement, prevTab);
					this.setHeight(prevTabElement);
				} else {
					const lastTab = this.tabButtons[this.tabButtons.length - 1];
					const lastTabElement = this.tabs.find(tab => tab.dataset.tab === lastTab.dataset.tab);
					this.setActiveTab(lastTabElement, lastTab);
					this.setHeight(lastTabElement);
				}
			});
		}
		scrollTo() {
			const el = window.innerWidth < 768 ? '.horizontal-tabs__tabs' : '.horizontal-tabs__header';
			let navigationHeight = document.querySelector('.site-header').scrollHeight;
			console.log(navigationHeight);
			gsap.to(window, {
				duration: 0.5,
				scrollTo: {
					y: el,
					offsetY: navigationHeight + 30,
					autoKill: false,
				},
				ease: 'power2.out',
			});
		}
	}

	horizontalTabs.forEach(tab => {
		new Tabs(tab).init();
	});
})();
